
export default function PaintTierComparison() {
  const tiers = [
    {
      name: 'Everyday',
      subtitle: 'Interior walls and ceilings',
      description: 'For standard residential painting applications',
      bg: '#F2C612',
      textColor: 'text-black',
      subtitleColor: 'text-black/80',
      checkColor: 'text-black/70',
      features: [
        'Good coverage and finish',
        'Low VOC formula',
        'Easy application',
        'Multiple color options',
        'Interior use',
      ],
    },
    {
      name: 'Contractor Grade',
      subtitle: 'Enhanced performance for demanding jobs',
      description: 'Professional-grade coverage for challenging applications',
      bg: '#2D7AC2',
      textColor: 'text-white',
      subtitleColor: 'text-white/90',
      checkColor: 'text-white/80',
      features: [
        'Superior coverage',
        'Interior and exterior use',
        'Stain-resistant finish',
        'Mold and mildew resistant',
        'Washable surface',
        'Extended durability',
      ],
    },
    {
      name: 'Elite Pro Series',
      subtitle: 'Maximum performance coating',
      description: 'Ultimate performance for critical commercial work',
      bg: '#D42B2B',
      textColor: 'text-white',
      subtitleColor: 'text-white/90',
      checkColor: 'text-white/80',
      features: [
        'Premium all-surface formula',
        'Commercial-grade performance',
        'Maximum coverage and hide',
        'Advanced stain resistance',
        'Self-priming technology',
        'Weather-resistant',
        'Ultra-durable finish',
      ],
    },
  ];

  return (
    <section className="py-12 md:py-20 px-4 md:px-8 bg-gray-50 overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-['Montserrat'] font-bold text-2xl md:text-3xl lg:text-4xl text-center mb-4 text-[#1A1A1A]">
          Choose Your Grade
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-10 md:mb-16 max-w-3xl mx-auto">
          Find the perfect paint for your project with the right balance of quality and value.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {tiers.map((tier) => (
            <div
              key={tier.name}
              className="rounded-xl p-6 md:p-8"
              style={{ backgroundColor: tier.bg }}
            >
              <h3 className={`font-['Montserrat'] font-bold text-xl md:text-2xl mb-1 ${tier.textColor}`}>
                {tier.name}
              </h3>
              <p className={`font-semibold text-sm mb-1 ${tier.subtitleColor}`}>
                {tier.subtitle}
              </p>
              <p className={`text-sm mb-5 ${tier.subtitleColor}`}>
                {tier.description}
              </p>
              <ul className="space-y-3">
                {tier.features.map((feature, index) => (
                  <li key={index} className={`flex items-center gap-2 text-sm md:text-base ${tier.textColor}`}>
                    <i className={`ri-check-line text-lg flex-shrink-0 ${tier.checkColor}`}></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
